<template>
  <div
    class="overflow-hidden border-solid border-r-0 border-t-0 border-b-0 border-l border-soft flex flex-col z-10 items-center">
    <div class="flex flex-col h-full">
      <div class="flex flex-col gap-2 w-full">
        <base-label id="preview"
                    label="Chat preview"
                    :label-classes="'font-bold'"
        />
        <base-select v-model="selectedChatPreview"
                     name="preview"
                     :options="chatPreviewOptions"
                     class="w-full border-gray h-10 mb-6 text-xl"
                     useOptionSlot
                     useLabelSlot
        >
          <template #option="{option}">
            <component :is="getPreviewIcon(option.value)" class="h-4 mr-1"/>
            {{ option.text }}
          </template>

          <template #label="{option}">
            <div class="flex items-center">
              <component :is="getPreviewIcon(option.value)" class="h-4 mr-1"/>
              {{ option.text }}
            </div>
          </template>
        </base-select>
      </div>

      <div v-if="theme.themeConfig && theme.langConfig" class="flex flex-col h-full w-full">
        <ChatWidget :selected-chat-preview="selectedChatPreview"
                    :theme-config="theme.themeConfig"
                    :lang-config="theme.langConfig"
                    :image-cache="imageCache"
                    class="flex-1"
        />
        <ChatLauncher class="mt-6 self-end"
                      :theme-config="theme.themeConfig"
                      :lang-config="theme.langConfig"
                      :button-icon-cache="imageCache.buttonIcon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseLabel from '@/components/base-components/BaseLabel.vue'
import BaseSelect from '@/components/base-components/BaseSelect.vue'
import ChatLauncher from '@/components/settings/bot-theme/chat-widget/components/chat/ChatLauncher.vue'
import ChatWidget from '@/components/settings/bot-theme/chat-widget/components/chat/ChatWidget.vue'
import values from 'ramda/src/values'
import { CHAT_ELEMENTS } from '@/constants/chat-theme.constants'
import { FileIcon, ListIcon, MessageCircleIcon, SendIcon, UserIcon } from 'vue-feather-icons'

export default {
  name: 'SettingsBotThemePreview',

  components: { BaseLabel, BaseSelect, ChatWidget, ChatLauncher },

  props: {
    theme: {
      type: Object,
      default: () => {}
    },
    imageCache: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      chatPreviewOptions: values(CHAT_ELEMENTS),
      selectedChatPreview: CHAT_ELEMENTS.buttons
    }
  },

  methods: {
    values,

    getPreviewIcon(chatPreview) {
      return {
        [CHAT_ELEMENTS.buttons]: SendIcon,
        [CHAT_ELEMENTS.quickReplies]: MessageCircleIcon,
        [CHAT_ELEMENTS.carousel]: ListIcon,
        [CHAT_ELEMENTS.clientInput]: UserIcon,
        [CHAT_ELEMENTS.fileAttachment]: FileIcon
      }[chatPreview]
    }
  }
}
</script>
